import { MarkerClustererF, MarkerF } from "@react-google-maps/api";
import { memo } from "react";
import { EditableFence } from "./types";
import { centroidOf } from "./mapUtils";
import { FENCE_STYLES } from "./PolygonContainer";

type FenceMarkersProps = {
  fences: EditableFence[];
  onSelect: (fence: EditableFence) => void;
  onHover: (locationId: string | null) => void;
};

const CLUSTER_OPTIONS = {
  averageCenter: true,
  gridSize: 60,
  minimumClusterSize: 2,
  zoomOnClick: true,
};

let markerIcon: google.maps.Symbol | undefined;
const getMarkerIcon = () =>
  (markerIcon ??= {
    path: google.maps.SymbolPath.CIRCLE,
    scale: 6,
    fillColor: FENCE_STYLES.ACTIVE.fillColor as string,
    fillOpacity: 0.9,
    strokeColor: "#ffffff",
    strokeWeight: 1.5,
  });

/**
 * Zoomed-out view of the fences. Below street zoom a fence is smaller than a
 * pixel, so instead of hundreds of polygons we show one clustered marker per
 * fence. Clicking a cluster zooms into it; clicking a marker selects the fence
 * and zooms to it.
 */
const FenceMarkers = memo(function FenceMarkers({ fences, onSelect, onHover }: FenceMarkersProps) {
  return (
    <MarkerClustererF options={CLUSTER_OPTIONS}>
      {(clusterer) => (
        <>
          {fences.map((fence) => (
            <MarkerF
              key={fence.locationId}
              position={centroidOf(fence.coordinates)}
              clusterer={clusterer}
              icon={getMarkerIcon()}
              title={fence.name || "Unnamed fence"}
              onClick={() => onSelect(fence)}
              onMouseOver={() => onHover(fence.locationId)}
              onMouseOut={() => onHover(null)}
            />
          ))}
        </>
      )}
    </MarkerClustererF>
  );
});

export default FenceMarkers;
